import Backbone from 'backbone'
import template from './scorecard-item-import-step2.hbs'
import SourceDataPanel from 'scoreboard/imports/source-data-panel'
import _ from 'lodash'
import $ from 'jquery'
import renderSheetIndexSelect from 'scoreboard/imports/render-sheet-index-select'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import appDisplay from 'scoreboard/components/app-display'
import ImportResultsDialog from 'scoreboard/components/import-results-dialog'

var ScorecardItemImportStep2 = Backbone.View.extend({

	tagName: 'form',

	className: 'import-source-data',

	events: {
		'change [name=sheetIndex]': 'refreshData',
		'change input[type=checkbox]': 'checkboxChange',
		'click .show-all': 'refreshData'
	},

	/**
	 * Renders the 2nd step of the scorecard structure
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.model
	 *
	 */
	initialize(options = {}) {
		this.options = options
		const MyFormView = FormView.extend({
			test: this.test.bind(this)
		})
		this.formView = new MyFormView({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: () => _.isNil(this.test())
		})
	},

	render() {
		this.$el.empty().append(template(this.context()))
		let metadata = this.model.get('dataSourceMetadata')
		renderSheetIndexSelect(this.el, metadata.sheets, metadata.sheetIndex)
		this.renderSourceDataPanel()

		this.options.wizard && this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})

		this.formView.start()
		this.toggleShowAll()
		return this
	},

	renderSourceDataPanel() {
		this.sourceDataPanel && this.sourceDataPanel.remove()
		this.sourceDataPanel = new SourceDataPanel({
			model: this.model,
			validMappingOptions: this.validMappingOptions.bind(this),
			formView: this.formView
		})
		this.$('.preview-panel').append(this.sourceDataPanel.el)
		this.sourceDataPanel.render()

		if (this.model.isDatabase()) {
			// #44888 mark the first row as the header row for db imports
			// (no checkbox is displayed)
			let headerRow = this.$('table tbody tr:first')
			headerRow.addClass('is-ignored')
		} else {
			// #27491 set the first row as ignored
			let cb = this.$('input:checkbox:first')
			cb.prop('checked', true)
			this.toggleIgnoredRow(cb)
		}
	},

	checkboxChange: function(e) {
		let cb = $(e.target)
		this.toggleIgnoredRow(cb)
		this.formView.clearErrors()
	},

	toggleIgnoredRow: function(cb) {
		let row = cb.closest('tr')
		let ignored = cb.prop('checked')
		row.toggleClass('is-ignored', ignored)
	},

	// updates source data panel after changing selected worksheet
	refreshData: function (e) {
		this.saveState()
		let url = _.result(this.model, 'getSourceDataPreviewUrl')
		let previousColumnMappings
		if ($(e.target).hasClass('show-all')) {
			url += '/all'
			// #33122 if we are refreshing the data after clicking "show all rows",
			// we want retain any currently selected column mappings
			previousColumnMappings = this.model.get('columnMappings')
		}
		return $.ajax({
			method: 'post',
			data: JSON.stringify(this.model),
			url,
			success: response => {
				this.model.set(response)
				if (!_.isNil(previousColumnMappings)) {
					// #33122 restore the previous columnMapping selections
					this.model.set('columnMappings', previousColumnMappings)
				}
				this.renderSourceDataPanel()
				this.toggleShowAll()
			},
			error: (xhr) => {
				this.formView.error(xhr)
			}
		})
	},

	toggleShowAll: function () {
		let displayShowAll = this.model.get('dataSourceMetadata').displayShowAll
		this.$('.show-all-rows').toggleClass('is-not-displayed', !displayShowAll)
	},

	validMappingOptions () {
		// if there is already a scorecard root, remove "Scorecard" as an available mapping
		let rootId = _.get(this.options, 'wizard.options.rootId')
		if (rootId) {
			return ALL_MAPPING_OPTIONS.filter(o => o.id !== 'root')
		}
		return ALL_MAPPING_OPTIONS
	},

	test() {
		// sourceDataPanel.test() requires at least one mapping
		let problem = this.sourceDataPanel.test()

		if (problem) {
			return problem
		}

		// at least one row should be not ignored
		const rowSelected = this.$('input:checkbox.use-row:not(:checked)').length > 0
		if (!rowSelected) {
			return i18n.get('admin.import.selectRow')
		}
	},

	saveState: function() {
		let data = {}

		data.columnMappings = this.getColumnMappings()

		let ignoreRows = []
		_.each(this.$('input:checkbox.use-row:checked'), (cbx) => {
			ignoreRows.push(cbx.value)
		})
		_.set(this.model.attributes.dataSourceMetadata, 'ignoreRows', ignoreRows.map(Number))

		let sheetIndex = this.$('[name=sheetIndex]').val()
		_.set(this.model.attributes.dataSourceMetadata, 'sheetIndex', sheetIndex)

		data.destinationItemId = _.get(this.options, 'wizard.options.itemId')
		data.destinationOrganization = {id: _.get(this.options, 'wizard.options.organizationId')}

		this.model.set(data)
	},

	getColumnMappings: function() {
		let columnMappings = {}
		columnMappings.thresholdColumns = []
		columnMappings.perspectiveColumns = []
		columnMappings.objectiveColumns = []
		columnMappings.genericColumns = []
		columnMappings.metricColumns = []
		let headerVals = this.sourceDataPanel.porter.val()

		_.each(headerVals, (typePackages, columnName) => {
			if (columnName === 'available') {
				return
			}
			// only 1 package allowed in each column
			let typePackage = typePackages[0]
			if (typePackage) {
				let colType = typePackage.id
				if (colType === 'threshold') {
					columnMappings.thresholdColumns.push(columnName)
				} else if (colType === 'perspective') {
					columnMappings.perspectiveColumns.push(columnName)
				} else if (colType === 'objective') {
					columnMappings.objectiveColumns.push(columnName)
				} else if (colType === 'generic') {
					columnMappings.genericColumns.push(columnName)
				} else if (colType === 'metric') {
					columnMappings.metricColumns.push(columnName)
				} else {
					columnMappings[colType + 'Column'] = columnName
				}
			}
		})
		return columnMappings
	},

	context: function() {
		return {
			title: i18n.get('admin.import.scorecard.scorecardImport')
		}
	},

	url: function() {
		return 'api/imports/scorecard-items'
	},

	countMessageKey: function() {
		return 'admin.import.scorecardItem'
	},

	submit() {
		this.saveState()
		console.dir(this.model.attributes)

		return $.ajax({
			method: 'post',
			data: JSON.stringify(this.model.attributes),
			url: this.url(),
			success: results => {
				let resultsDialog = new ImportResultsDialog({
					results,
					problemMessageKey: 'admin.import.hadProblems',
					countMessageKey: this.countMessageKey()
				})
				appDisplay.replaceDialog(resultsDialog)
				resultsDialog.on('done', () => this.options.wizard.finish())
			},
			error: (xhr) => {
				let errors = xhr.responseJSON ? xhr.responseJSON.errors : false // validation errors
				if (errors) {
					let messages = _.map(errors, 'message')
					this.formView.errorMessages(messages)
				} else { // other types of errors
					this.formView.error(xhr)
				}
			}
		})
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.sourceDataPanel], 'remove')
	}

})

const ALL_MAPPING_OPTIONS = [
	{ id: 'root', label: 'scorecards.node.scorecardRoot', multiple:false },
	{ id: 'perspective', label: 'scorecards.node.perspective', multiple: true },
	{ id: 'objective', label: 'scorecards.node.objective', multiple: true },
	{ id: 'generic', label: 'scorecards.node.generic', multiple: true },
	{ id: 'metric', label: 'scorecards.node.metric', multiple: true },
	{ id: 'scoringType', label: 'report.customReport.scoringType', multiple: false },
	{ id: 'dataType', label: 'scorecards.node.metric.dataType.dataType', multiple: false },
	{ id: 'units', label: 'scorecards.node.metric.dataType.units', multiple: false },
	{ id: 'aggregationType', label: 'scorecards.node.metric.aggregationType.aggregationType', multiple: false },
	{ id: 'calendar', label: 'common.calendar.calendar', multiple: false },
	{ id: 'weight', label: 'scorecards.node.weight', multiple: false },
	{ id: 'yesGood', label: 'scorecards.node.metric.isYesGood', multiple: false },
	{ id: 'higherBetter', label: 'scorecards.node.metric.higherValuesBetter', multiple: false },
	{ id: 'description', label: 'common.description', multiple: false },
	{ id: 'start', label: 'admin.scorecards.hideBefore', multiple: false },
	{ id: 'archive', label: 'admin.scorecards.hideAfter', multiple: false },
	{ id: 'tags', label: 'common.tags', multiple: false },
	{ id: 'threshold', label: 'scorecards.node.metric.threshold', multiple: true }
]

export default ScorecardItemImportStep2

ScorecardItemImportStep2.__filename__ = 'scorecards/edit/import/scorecard-item-import-step2.js'
